import {
  Component,
  EventEmitter,
  Listen,
  Prop,
  Event,
  h,
  State,
} from "@stencil/core";
import { navContentStore } from "@phn/state/nav-content-store";
import { navStateStore } from "@phn/state/nav-state-store";
import { dealerSearchResultsStore } from "../../state/dealer-search-results-store";
import {
  findTopLevelRoutingKey,
  getLastRoutingSegment,
  RoutingKeys,
} from "@phn/entities/routing-key";
import VehiclePurchaseSection from "./sections/vehiclePurchase";
import { isDesktop, isString } from "@phn/utility/helper";
import Electric from "./sections/electric";
import ShopSection from "./sections/shop";

@Component({
  tag: "phn-nd-router",
  scoped: true,
  styleUrl: "router.scss",
})
export class Router {
  @Prop() activeRoutingKey!: string;

  @Prop() breakpoint!: number;

  @Prop() locale!: string;

  @Prop() modelType?: string;

  @Prop() receivedContent = false;

  @State() showWishlist = false;

  @Event() phnLogin!: EventEmitter<void>;

  @Listen("showWishlist")
  showWishlistHandler({ detail }) {
    this.showWishlist = detail;
  }

  render(): HTMLPhnNdRouterElement {
    const { models, account, dealer } = navContentStore.state;
    const topLevelRoutingKey = findTopLevelRoutingKey(this.activeRoutingKey);
    const isMobile = !isDesktop(this.breakpoint);

    switch (topLevelRoutingKey) {
      case RoutingKeys.DEALER_SEARCH: {
        const routingId = getLastRoutingSegment(this.activeRoutingKey);
        const dealerId = routingId !== topLevelRoutingKey ? routingId : "";

        const searchForm = (
          <phn-nd-dealer-search-form
            breakpoint={this.breakpoint}
            dealer={dealer}
            locale={this.locale}
            showHeadline={isMobile}
          />
        );

        if (isString(dealerId)) {
          return isMobile ? (
            <phn-nd-dealer-card
              locale={this.locale}
              dealer={dealerSearchResultsStore.state.ppnDealers[dealerId]}
              class="router-dealer-card"
              isFlyout={true}
            />
          ) : (
            searchForm
          );
        }

        return searchForm;
      }

      case RoutingKeys.ACCOUNT:
      case RoutingKeys.MY_PORSCHE: {
        if (account?.text) {
          return <phn-nd-account-drawer class="overlay-content" />;
        }

        return <div></div>;
      }

      case RoutingKeys.SERIES:
      case RoutingKeys.MODELS: {
        if (models !== null) {
          const routingId = getLastRoutingSegment(this.activeRoutingKey);
          const activeModelsSeries = models.series.find(
            (modelsSeries) => routingId === modelsSeries.id,
          );

          if (activeModelsSeries !== undefined) {
            if (this.modelType) {
              navStateStore.state.modelType = this.modelType;
            }
            if (!navStateStore.state.preloadedSeriesImages) {
              navStateStore.state.preloadedSeriesImages = {};
            }
            return (
              <phn-nd-car-body-types-drawer
                series={activeModelsSeries}
                breakpoint={this.breakpoint}
              />
            );
          }

          return (
            <phn-nd-models
              showHeadline={isMobile}
              breakpoint={this.breakpoint}
            />
          );
        }
        return <div></div>;
      }
      case RoutingKeys.ELECTRIC: {
        return (
          <Electric
            activeRoutingKey={this.activeRoutingKey}
            topLevelRoutingKey={topLevelRoutingKey}
            receivedContent={this.receivedContent}
            breakpoint={this.breakpoint}
          />
        );
      }

      case RoutingKeys.MORE:
      case RoutingKeys.EXPERIENCE:
      case RoutingKeys.SERVICES:
      case RoutingKeys.VEHICLE_PURCHASE: {
        return (
          <VehiclePurchaseSection
            activeRoutingKey={this.activeRoutingKey}
            topLevelRoutingKey={topLevelRoutingKey}
            receivedContent={this.receivedContent}
            breakpoint={this.breakpoint}
          />
        );
      }

      case RoutingKeys.SHOP:
        return (
          <ShopSection
            activeRoutingKey={this.activeRoutingKey}
            receivedContent={this.receivedContent}
            breakpoint={this.breakpoint}
            phnLogin={this.phnLogin}
            showWishlist={this.showWishlist}
          />
        );

      default: {
        return (
          <phn-nd-level-1 locale={this.locale} breakpoint={this.breakpoint} />
        );
      }
    }
  }
}
